var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.$style.discount, { [_vm.$style.small] : _vm.small}]},[_c('b',[_vm._v(" -"+_vm._s(_vm.discount)+"% ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }